import React from 'react'
import { NavLink } from 'react-router-dom'
import PropTypes from 'prop-types'

import { Event } from '../../../../../../entities/Event'

import './AsideEventCard.css'

const AsideEventCard = ({ event, isActive }) => {
    const fileIcon = event.getFileIcon(isActive)
    const { slug, displayDateAndTime, title, hasDocuments } = event

    return (
        <div className="aside-event">
            <NavLink to={`/dogadjaj/${slug}`} activeClassName="active-event">
                <div className="aside-event__date">{displayDateAndTime}</div>
                <div className="aside-event__title">
                    <div className="aside-event__title__text">{title}</div>
                    {hasDocuments && (
                        <div
                            className="aside-event__title__icon"
                            style={{ backgroundImage: `url("${fileIcon}")` }}
                        />
                    )}
                </div>
            </NavLink>
        </div>
    )
}

AsideEventCard.propTypes = {
    event: PropTypes.instanceOf(Event).isRequired,
    isActive: PropTypes.bool
}

export { AsideEventCard }
